module.exports = __webpack_public_path__ + "static/media/Background_Bottom.b5484f95.png";